import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import {
  Carousel, Container, Row,
  Col, Card,
} from 'react-bootstrap'
import { Button, Breadcrumb } from 'antd'
import {
  PlayCircleTwoTone, GlobalOutlined, ShoppingOutlined,
  PhoneOutlined, ReadOutlined, CalendarOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons'
import { InfoCard, MitraCard, ArticleCard } from 'components/elements'

const AssistanceGoverment = ({ scrollToTop }) =>
// const top = useRef(null)
// if (scrollToTop) {
//   top.current.scrollIntoView({ behavior: 'smooth' })

// }

  (
    <div className="h-100">
      {/* <div ref={top}/> */}
      {/*= ========= breadcrumb section ========== */}
      <section className="py-4 bg-pearl-blue">
        <Container className="section-header">
          <Breadcrumb>
            <Breadcrumb.Item>
              <a href="/">Home</a>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Bantuan Pemerintah</Breadcrumb.Item>
          </Breadcrumb>
        </Container>
      </section>

      {/*= ========= article liputan section ========== */}
      <section className="py-5 bg-pearl-blue">
        <Container className="section-header">
          <div className="title-wrapper text-center mb-5">
            <h2>BANTUAN PEMERINTAH</h2>
            <h3>
              Cari tahu informasi terbaru mengenai Bantuan Pemerintah
              <span>SIPLah</span>
            </h3>
            <p>Liputan Siplah</p>
          </div>
          <Row>
            <Col lg={12} className="mb-5">
              <ArticleCard
                thumbnailImg="./assets/article-pemerintah-1.jpeg"
                title="Daftar Bantuan Pemerintah Tahun 2020"
                url="https://siplah.kemendikdasmen.go.id/index.php/banper_siplah/entry/daftar-bantuan-pemerintah-tahun-2020"
                date="24 Nov 2020"
                shortDescription={(
                  <React.Fragment>
                    <p>Menampilkan informasi terkait Daftar Bantuan Pemerintah Tahun 2020</p>
                    <p>Pedoman Pelaksanaan Bantuan Kesiapan Bersekolah PAUD 2020</p>
                    <p>Petunjuk Pelaksanaan Banper TIK Sekolah Dasar (SD) 2020</p>
                    <p>Petunjuk Teknis Bantuan Pemerintah SMK 2020</p>
                  </React.Fragment>
                )}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  )


AssistanceGoverment.propTypes = {
  scrollToTop: PropTypes.bool,
}

export default AssistanceGoverment
